import { logError } from '@util/logger'

export function logSchemaValidationError(schemaName: string, e: unknown, data: unknown): void {
    logError(e, {
        metadata: {
            issue: 'schemaValidation',
            schemaName,
            incomingJson: data,
        },
    })
}
